import React, { useState } from "react";
import WebsiteLayout from "../layouts/WebsiteLayout";
import Banner from "../components/Banner";
import { useQuery } from "@tanstack/react-query";
import { getReceipts } from "../api/receipts.api";
import { Modal } from "react-bootstrap";
import { queryError } from "../utils/helpers";

let banner = require("../assets/images/gallery.jpeg");

const ensureAbsoluteUrl = (url) => {
  if (!url) return "";
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  return "https://" + url;
};

const isPdf = (format, url) => {
  if (format === "pdf") return true;
  if (url && url.toLowerCase().endsWith(".pdf")) return true;
  return false;
};

const Receipts = () => {
  const { data } = useQuery(['public-receipts'], getReceipts, {
    onError: () => queryError()
  });

  const receipts = data?.value || [];
  const [selectedReceipt, setSelectedReceipt] = useState(null);

  return (
    <WebsiteLayout>
      <Banner title="Drinks Purchase Receipts" link="Receipts" bannerImage={banner} />
      <section className="sb-menu-section sb-p-90-90">
        <div className="sb-bg-1">
          <div />
        </div>
        <div className="container">
          <div className="sb-masonry-grid">
            <div className="sb-grid-sizer" />
            {receipts.length > 0 ? (
              receipts.map(receipt => {
                const fullUrl = ensureAbsoluteUrl(receipt.fileUrl);
                const isReceiptPdf = isPdf(receipt.format, receipt.fileUrl);
                return (
                  <div key={receipt._id} className="sb-grid-item sb-item-33">
                    <div className="sb-menu-item sb-mb-30">
                      <div className="sb-card-tp">
                        <h4 className="sb-card-title">{receipt.title}</h4>
                      </div>
                      <div
                        className="sb-description"
                        style={{ textAlign: "center", cursor: "pointer" }}
                        onClick={() => setSelectedReceipt({ ...receipt, fullUrl, isReceiptPdf })}
                      >
                        {isReceiptPdf ? (
                          <iframe src={fullUrl} width="100%" height="300px" title={receipt.title} style={{ pointerEvents: "none" }}></iframe>
                        ) : (
                          <img src={fullUrl} alt={receipt.title} style={{ width: "100%", height: "300px", objectFit: "cover" }} />
                        )}
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <h4 className="text-center w-100">No receipts uploaded yet.</h4>
            )}
          </div>
        </div>
      </section>

      {/* Full-size receipt modal */}
      <Modal show={selectedReceipt !== null} onHide={() => setSelectedReceipt(null)} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{selectedReceipt?.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: 0 }}>
          {selectedReceipt && (
            selectedReceipt.isReceiptPdf ? (
              <iframe src={selectedReceipt.fullUrl} width="100%" height="80vh" title={selectedReceipt.title} style={{ minHeight: "70vh", border: "none" }}></iframe>
            ) : (
              <img src={selectedReceipt.fullUrl} alt={selectedReceipt.title} style={{ width: "100%", display: "block" }} />
            )
          )}
        </Modal.Body>
      </Modal>
    </WebsiteLayout>
  );
};

export default Receipts;
